import AccordionCustomComponent from "components/common/layouts/Accordion";
import { WebhookForm } from "./webhook-form";
export function WebhookAccordion() {
  return <AccordionCustomComponent title={"Webhook"}>
			<WebhookForm />
		</AccordionCustomComponent>;
}